import { colord } from 'colord';

interface SiteData {
  colour?: string;
}

export const defineColor = (color: string, name: string): void => {
  const doc = document.documentElement;
  const hsl = colord(color).toHsl();
  const { h: hue, s: saturation, l: lightness } = hsl;
  const baseLightness = lightness < 80 ? lightness : 80;

  const increments = {
    dark: baseLightness > 10 ? (baseLightness - 10) / 4 : 0,
    light: baseLightness < 90 ? (90 - baseLightness) / 4 : 0,
  };

  const palette = {
    100: baseLightness - increments.dark * 4,
    200: baseLightness - increments.dark * 3,
    300: baseLightness - increments.dark * 2,
    400: baseLightness - increments.dark,
    500: baseLightness,
    600: baseLightness + increments.light,
    700: baseLightness + increments.light * 2,
    800: baseLightness + increments.light * 3,
    900: baseLightness + increments.light * 4,
  };

  doc.style.setProperty(
    `--ss-ui-color-${name}-100`,
    `hsl(${hue}deg, ${saturation}%, ${palette[100]}%)`,
  );

  doc.style.setProperty(
    `--ss-ui-color-${name}-200`,
    `hsl(${hue}deg, ${saturation}%, ${palette[200]}%)`,
  );

  doc.style.setProperty(
    `--ss-ui-color-${name}-300`,
    `hsl(${hue}deg, ${saturation}%, ${palette[300]}%)`,
  );

  doc.style.setProperty(
    `--ss-ui-color-${name}-400`,
    `hsl(${hue}deg, ${saturation}%, ${palette[400]}%)`,
  );

  doc.style.setProperty(
    `--ss-ui-color-${name}-500`,
    `hsl(${hue}deg, ${saturation}%, ${palette[500]}%)`,
  );

  doc.style.setProperty(
    `--ss-ui-color-${name}-600`,
    `hsl(${hue}deg, ${saturation}%, ${palette[600]}%)`,
  );

  doc.style.setProperty(
    `--ss-ui-color-${name}-700`,
    `hsl(${hue}deg, ${saturation}%, ${palette[700]}%)`,
  );

  doc.style.setProperty(
    `--ss-ui-color-${name}-800`,
    `hsl(${hue}deg, ${saturation}%, ${palette[800]}%)`,
  );

  doc.style.setProperty(
    `--ss-ui-color-${name}-900`,
    `hsl(${hue}deg, ${saturation}%, ${palette[900]}%)`,
  );

  doc.style.setProperty(
    `--ss-ui-color-${name}-1000`,
    `hsl(${hue}deg, ${saturation}%, 97%)`,
  );

  if (colord(color).brightness() > 0.75) {
    doc.style.setProperty(
      `--ss-ui-color-${name}-contrast`,
      `hsl(${hue}deg, ${saturation}%, 10%)`,
    );
  } else {
    doc.style.setProperty(
      `--ss-ui-color-${name}-contrast`,
      `hsl(${hue}deg, ${saturation}%, 100%)`,
    );
  }
};

/**
 * @category Initialization
 * @subcategory Theme Creator
 * @module createTheme
 * @param {object} siteData - User's site date direct from API
 */
export const createTheme = (
  siteData: SiteData = { colour: 'hsl(261deg, 62%, 50%)' },
): void => {
  if (siteData.colour) {
    defineColor(siteData.colour, 'primary');
  }
};

export default createTheme;
